// SEARCH PRODUCT ACTION ASYNC TYPES
export const LOAD_SIMILAR_PRODUCTS_REQUEST = 'LOAD_SIMILAR_PRODUCTS_REQUEST';
export const LOAD_SIMILAR_PRODUCTS_SUCCESS = 'LOAD_SIMILAR_PRODUCTS_SUCCESS';
export const LOAD_SIMILAR_PRODUCTS_FAILURE = 'LOAD_SIMILAR_PRODUCTS_FAILURE';

export const SIMILAR_PRODUCTS_TITLE = 'Products Related To %1$s';

export const TOP_SIMILAR_TECH_TO_SHOW = 5;
